var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"author-puzzles"},[_c('h2',[_c('router-link',{attrs:{"to":{
        name: 'user',
        params: {
          userId: _vm.authorId
        }
      }}},[_vm._v(_vm._s(_vm.user.name))]),_vm._v("'s Puzzles\n  ")],1),_vm._v(" "),_c('pagination',{attrs:{"resourceUrl":_vm.puzzlesUrl,"pageSize":_vm.$root.defaultPageSize,"orderBy":"date","orderType":"DESC"},scopedSlots:_vm._u([{key:"paged_item",fn:function(item){return [_c('puzzle-list',{attrs:{"puzzle":item}})]}}],null,false,661399226)})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70eb608b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AuthorPuzzles.vue
// module id = 1224
// module chunks = 1